import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconMoneyRed = createIcon({
  path: (
    <>
      <path
        d="M4.60742 9.12774C4.60742 7.36042 6.04011 5.92773 7.80742 5.92773H14.4646C16.1214 5.92773 17.4646 7.27088 17.4646 8.92773V10.9992C17.4646 12.656 16.1214 13.9992 14.4646 13.9992H7.20742C5.77148 13.9992 4.60742 12.8351 4.60742 11.3992V9.12774Z"
        fill="#FAE5E5"
      />
      <rect
        x="1.42871"
        y="5"
        width="6.57143"
        height="1.92857"
        rx="0.964286"
        fill="#D50000"
      />
      <rect
        x="1.42871"
        y="9"
        width="5.42857"
        height="1.92857"
        rx="0.964285"
        fill="#D50000"
      />
      <rect
        x="1.42871"
        y="13.0713"
        width="3.92857"
        height="1.92857"
        rx="0.964285"
        fill="#D50000"
      />
      <ellipse
        cx="11.4651"
        cy="9.92801"
        rx="1.64286"
        ry="1.64286"
        fill="#D50000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.02471 5.92815C9.02471 5.39559 9.45644 4.96387 9.989 4.96387H15.7504C17.3086 4.96387 18.5718 6.22706 18.5718 7.7853V12.1424C18.5718 13.7007 17.3086 14.9639 15.7504 14.9639H7.393C6.86044 14.9639 6.42871 14.5321 6.42871 13.9996C6.42871 13.467 6.86044 13.0353 7.393 13.0353H15.7504C16.2435 13.0353 16.6432 12.6355 16.6432 12.1424V7.7853C16.6432 7.29218 16.2435 6.89244 15.7504 6.89244H9.989C9.45644 6.89244 9.02471 6.46071 9.02471 5.92815Z"
        fill="#D50000"
      />
    </>
  ),
});

export default IconMoneyRed;
